import { useEffect, useRef } from 'react';
import { useToast } from '@aimsos/ui';

/**
 * A ref that always holds the current toast API, so async callbacks can toast without taking
 * `toast` as a dependency (it would recreate them on every provider update).
 */
export const useToastRef = () => {
  const toast = useToast();
  const toastRef = useRef(toast);
  useEffect(() => {
    toastRef.current = toast;
  }, [toast]);
  return toastRef;
};
